export * from './delete-kunden-art-request.interface';
export * from './delete-kunden-art-response.interface';
export * from './delete-kunden-art.shapes';
